import { supabase } from './supabase';

/**
 * Ressalva de quem emite com um CPF/CNPJ que já saiu com o nome de outra pessoa.
 *
 * Até 02/10/2026 esse caso era barrado e só admin liberava (#6155). Passou a ser
 * liberado para quem emite, desde que escreva o porquê (#6160): a decisão fica
 * registrada em system_logs (EMIT_BOLETO) e em faturas.ressalva_pagador.
 */
export { RESSALVA_MIN_CARACTERES, ressalvaValida } from './nomePagador';

/**
 * Grava (ou limpa) a ressalva do boleto atual da fatura. Melhor esforço: o boleto
 * já foi emitido quando isto roda, e o log do sistema guarda a ressalva de todo jeito
 * — inclusive antes da migration 20261002150000 criar a coluna.
 */
export async function gravarRessalvaPagador(faturaId: string | number | null | undefined, ressalva: string | null): Promise<void> {
    if (faturaId == null) return;
    try {
        const { error } = await supabase
            .from('faturas')
            .update({ ressalva_pagador: ressalva?.trim() || null })
            .eq('id', faturaId);
        if (error) console.warn('Ressalva do pagador não gravada na fatura:', error.message);
    } catch (e) {
        console.warn('Ressalva do pagador não gravada na fatura:', e);
    }
}
